const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/change-order-requests`,
    data: `${API_URL}/change-order-request/data`
};

export default apiUrls;
